import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configurations } from '../models/configurations';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private configs: Configurations | null = null;
  loaded: boolean = false;

  constructor(private http: HttpClient) { }

  loadConfigurations(configurationUrl: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.http
      .get<Configurations>(configurationUrl, { headers: { 'Cache-Control':  'no-cache, no-store, must-revalidate, post-check=0, pre-check=0', 'Pragma': 'no-cache', 'Expires': '0' }})
      .subscribe({ next: (data: any) => {
        this.configs = data;
        this.loaded = true;
        resolve();
      }, error: reject });
    });
  }

  get(): Configurations {
    if (this.configs == null) { console.error('Configurations weren\'t retrieved ahead of time.'); }
    return this.configs as Configurations;
  }
}


export function initConfig(appConfig: AppConfigService, configurationUrl: string) {
    return () => appConfig.loadConfigurations(configurationUrl);
}
